/**
 * No Bleed Banner.
 *
 * Yes I realize this should simply be an option in the full bleed banner
 * but client is pressing us for something.
 */
(function ($) {
	let arriveOptions = {
		onceOnly: true, // ensure that registered callbacks fire only once
		existing: true, // ensure that the registered callback is fired for the elements that already exist in the DOM and match the selector
	};

	const noBleedBanner = ".wp-block-cd-no-bleed-banner";
	const loadedClass = "is-loaded";

	let $noBleedBanner = $(noBleedBanner);
	let bannerImg = `${noBleedBanner} > img`;

	function scaleBanners() {
		$noBleedBanner.each(function () {
			let $container = $(this);
			let $image = $container.find("img.banner");
			scaleImageContainer($container, $image);
			$container.addClass(loadedClass);
		});
	}

	$(document).arrive(bannerImg, arriveOptions, scaleBanners);

	$(window).on("load resize", function () {
		scaleBanners();
	});
})(jQuery);
